import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Error from 'components/layout/Error/Error';
import Header from 'components/ui/Header/Header';
export default function Custom404() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Header, {
      useHome: true
    }), /*#__PURE__*/_jsx(Error, {})]
  });
}